///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActionsToolbarModeEnum, GtthStepGroupEnum } from '../../../../../generated/shared-types.model';
import { GtthToolbarModeChangedCommand } from './toolbar-mode-changed-command';

export class GtthChangeStepCommand extends GtthAbstractCommand {
    private newStep: GtthStepGroupEnum;

    getCommandName(): string {
        return 'GtthChangeStepCommand';
    }

    create(newStep: GtthStepGroupEnum): this {
        this.newStep = newStep;
        return this;
    }

    doCommand(): void {
        this.historyService.selectedStepNumber = this.newStep;

        if (!this.historyService.logicalTopology) {
            return;
        }

        this.historyService.clearSelectionCloseWindowAndArea();

        switch (this.newStep) {
            case GtthStepGroupEnum.LOCATIONS_AND_LOSES:
                this.locationAndLosesStepActivation();
                break;
            case GtthStepGroupEnum.PLAN_AND_OPTIMISE:
            case GtthStepGroupEnum.BOM:
                this.planAndOptimiseStepActivation();
                break;
        }

        this.historyService.projectUserSessionService.setStepGroup(this.newStep);
        this.commandResolve(false);
    }

    locationAndLosesStepActivation() {
        this.historyService.doCommandBypassHistory(
            this.historyService.command(GtthToolbarModeChangedCommand).create(ActionsToolbarModeEnum.POINTER)
        );

        if (this.historyService.isEditModeEnabled) {
            this.historyService.logicalTopology.enableEntitiesListeners();
        }
        this.historyService.logicalTopology.redrawTopologyLines();
        this.historyService.logicalTopology.redrawSectors(this.historyService);
        this.historyService.logicalTopology.stationsChangeDraggable();
        this.historyService.logicalTopology.changeStationIcons();
    }

    planAndOptimiseStepActivation() {
        this.historyService.doCommandBypassHistory(
            this.historyService.command(GtthToolbarModeChangedCommand).create(ActionsToolbarModeEnum.POINTER)
        );
        this.historyService.logicalTopology.disableEntitiesListeners();

        this.historyService.logicalTopology.redrawTopologyLines();
        this.historyService.logicalTopology.redrawSectors(this.historyService);
        this.historyService.logicalTopology.stationsChangeDraggable();
        this.historyService.logicalTopology.changeStationIcons();
        this.historyService.projectInfoViewService.setNumberOfConnectedTu(
            this.historyService.logicalTopology.getConnectedTerminalStationsCount()
        );
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
